import React, { useState } from 'react';
import './styles/index.scss';
import App from './App';
import '../node_modules/normalize.css/normalize.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import PrivacyAndTerms from './components/sections/PrivacyAndTerms';

const container = document.getElementById('root');
const root = createRoot(container);

const MainComponent = () => {
  const [showPrivacyAndTerms, setShowPrivacyAndTerms] = useState(true);

  const handleClose = () => {
    setShowPrivacyAndTerms(false);
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacy-terms" element={showPrivacyAndTerms ? <PrivacyAndTerms onClose={handleClose} /> : null} />
      </Routes>
    </BrowserRouter>
  );
};

root.render(
  <React.StrictMode>
    <MainComponent />
  </React.StrictMode>
);
